import React from 'react'
import './loading.css'

const Loader = () => {
  return (
    <div className='spinner'>
        <div className='item'></div>
    </div>
  )
}

export default Loader